import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect, useState } from 'react';
import axios from '@/lib/axios';

export const Route = createFileRoute('/(consumer)/_authenticated/chats/$id')({
  component: ChatConversationRedirect,
});

function ChatConversationRedirect() {
  const { id } = Route.useParams();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await axios.get<{ booking_id: string }>(
          `/chats/conversations/${id}/booking/`
        );
        const bookingId = res.data?.booking_id;
        if (!bookingId) {
          throw new Error('Missing booking id');
        }
        if (!cancelled) {
          await navigate({
            to: '/bookings/$id',
            params: { id: bookingId },
            replace: true,
          });
        }
      } catch {
        if (!cancelled) {
          setError('This chat link is invalid or you do not have access.');
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [id, navigate]);

  if (error) {
    return (
      <div className="max-w-lg mx-auto p-6 mt-24 text-center text-muted-foreground">
        {error}
      </div>
    );
  }

  return (
    <div className="max-w-lg mx-auto p-6 mt-24 text-center text-muted-foreground">
      Opening your booking…
    </div>
  );
}
